module.exports = __webpack_public_path__ + "static/img/software22.96ab653e.png";